<canvas #myCanvas
        [hidden]='true'
        class="icon-canvas">
</canvas>
